export const SUBSCRIPTION_POPULATE_FULL = [
    "strategy.exchanges",
    "pricingModel",
    "pm_paymentMethod",
    "bot_config",
];
export const SUBSCRIPTION_POPULATE_DEFAULT = [
    "strategy.exchanges",
    "pricingModel",
];
export const SUBSCRIPTION_POPULATE_LIST = [
    "strategy",
    "pricingModel",
];
export const SUBSCRIPTION_POPULATE_MINIMAL = ["strategy"];
export const SUBSCRIPTION_POPULATE = {
    FULL: SUBSCRIPTION_POPULATE_FULL,
    DEFAULT: SUBSCRIPTION_POPULATE_DEFAULT,
    LIST: SUBSCRIPTION_POPULATE_LIST,
    MINIMAL: SUBSCRIPTION_POPULATE_MINIMAL,
};
